module.exports = __webpack_public_path__ + "img/like_fail@2x.4dd30e67.png";